import axios from "axios";

import globalRouter from "../../src/components/globalRouter";

const api = axios.create({

    baseURL: (process.env.REACT_APP_API_URL || "__BACKEND_API__") + "/api/v1",
});



export default api


api.interceptors.response.use((response) => {
    return response
}, function (error) {
    switch (error.response.status) {
        case 401:
            localStorage.removeItem("token")
            globalRouter.navigate('/login')
            break;
        case 403:
            window.dispatchEvent(new CustomEvent('auth:forbidden', {
                detail: { url: error.config?.url, message: error.response?.data?.detail }
            }))
            return Promise.reject(error)
        case 402:
            // Licença expirada ou inválida
            console.warn("🚫 Licença expirada:", error.response?.data?.message);

            // Salva informações da licença para mostrar na página
            const licenseError = {
                message: error.response?.data?.message || "Licença expirada",
                error: error.response?.data?.error || "Licença inválida",
                timestamp: new Date().toISOString(),
                app: error.response?.data?.app || "Sistema"
            };

            localStorage.setItem("licenseError", JSON.stringify(licenseError));

            // Redireciona para página de licença expirada
            globalRouter.navigate('/license-expired');
            break;
        default:
            console.log(error.response)
            return Promise.reject(error)

    }

})


export const get_all = async (endpoint, limit = 10, offset = 0, order_by = undefined, order = undefined, query = "") => {
    const response = await api.post(endpoint, { limit, offset, order_by, order, query })
    return response
}

export const get_one = async (endpoint, id) => {
    const response = await api.get(endpoint + "/" + id)
    return response
}

export const create = async (endpoint, data) => {
    const response = await api.post(endpoint, data)
    return response
}

export const update = async (endpoint, id, data) => {
    const response = await api.put(endpoint + "/" + id, data)
    return response
}

export const delete_one = async (endpoint, id) => {
    const response = await api.delete(endpoint + "/" + id)
    return response
}